export default "__VITE_ASSET__ZSckyS7Z__"